export default function IconClose() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M10.3431 8.92888C9.95257 8.53836 9.3194 8.53836 8.92888 8.92888C8.53836 9.3194 8.53836 9.95257 8.92888 10.3431L14.5858 16L8.92895 21.6568C8.53843 22.0473 8.53843 22.6805 8.92895 23.071C9.31948 23.4615 9.95264 23.4615 10.3432 23.071L16 17.4142L21.6568 23.071C22.0473 23.4615 22.6805 23.4615 23.071 23.071C23.4615 22.6805 23.4615 22.0473 23.071 21.6568L17.4142 16L23.0711 10.3431C23.4616 9.95257 23.4616 9.31941 23.0711 8.92888C22.6806 8.53836 22.0474 8.53836 21.6569 8.92888L16 14.5858L10.3431 8.92888Z"
        fill="#1C1C1C"
      />
    </svg>
  );
}
